"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../core/table"));
var _helpButton = _interopRequireDefault(require("../../core/help-button"));
var _alert = _interopRequireDefault(require("../../core/alert"));
var _container = _interopRequireDefault(require("../../core/container"));
var _entryTypesHelp = _interopRequireDefault(require("./entry-types-help"));
var _entryTypeRow = _interopRequireDefault(require("./entry-type-row"));
var _sortableRowsContainer = _interopRequireDefault(require("../../core/sortable-rows-container"));
var _reactSortableHoc = require("react-sortable-hoc");
var _addEntryType = _interopRequireDefault(require("./add-entry-type"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const SortableEntryTypeRow = (0, _reactSortableHoc.SortableElement)(_entryTypeRow.default);
var _ref = /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_entryTypesHelp.default, null));
var _ref2 = /*#__PURE__*/_react.default.createElement(_addEntryType.default, null);
var _ref3 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref4 = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "warning"
}, "Changes to description, siwi code and overide bib Adjuster (used for siwi output) will immediately be used by existing competitions. Other changes will not imact existing competitions. Corresponding eligibilities to default races should be manually removed when an entry type is expired.");
var _ref5 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref6 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: 2
}, "Sort"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: 2
}, "ID"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: 2
}, "Description"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right",
  rowSpan: 2
}, "Priority"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right",
  rowSpan: 2
}, "Overide Bib Adjuster"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right",
  rowSpan: 2
}, "Siwi Code"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right",
  rowSpan: 2
}, "Can Pre-Register"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center",
  colSpan: 3
}, "Lead Time Overrides in Days")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Open For Entry"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Closed For Entry"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Late Fees Due")));
class EntryTypes extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onSort", entryTypes => {
      this.props.sortEntryTypes(entryTypes.map(refCode => refCode.id));
    });
  }
  render() {
    const entryTypeSets = [{
      setName: 'Current Entry Types',
      entryTypes: this.props.entryTypes.filter(et => !et.isExpired)
    }, {
      setName: 'Expired Entry Types',
      entryTypes: this.props.entryTypes.filter(et => et.isExpired)
    }];
    return /*#__PURE__*/_react.default.createElement(_container.default, null, _ref, _ref2, _ref3, _ref4, entryTypeSets.map(entryTypeSet => /*#__PURE__*/_react.default.createElement("div", {
      key: entryTypeSet.setName
    }, _ref5, /*#__PURE__*/_react.default.createElement("h5", null, entryTypeSet.setName), !entryTypeSet.entryTypes.length ? /*#__PURE__*/_react.default.createElement("p", null, entryTypeSet.setName === 'Expired Entry Types' ? 'No Entry Types have been expired' : 'No entry types') : /*#__PURE__*/_react.default.createElement(_table.default, null, _ref6, /*#__PURE__*/_react.default.createElement(_sortableRowsContainer.default, {
      items: entryTypeSet.entryTypes,
      onSort: this._onSort
    }, /*#__PURE__*/_react.default.createElement("tbody", null, entryTypeSet.entryTypes.map((entryType, index) => /*#__PURE__*/_react.default.createElement(SortableEntryTypeRow, {
      key: entryType.id,
      index: index,
      entryType: entryType
    }))))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref7 = {
  entryTypes: {
    id: true,
    description: true,
    openForOnlineEntryLeadTimeOverride: true,
    canPreRegister: true,
    closedForOnlineEntryLeadTimeOverride: true,
    lateFeesLeadTimeOverride: true,
    sortOrder: true,
    priority: true,
    overrideBibAdjuster: true,
    siwiCode: true,
    isExpired: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(EntryTypes, props => _ref7, (client, props) => ({
  sortEntryTypes(entryTypeIDs) {
    return client.update('EntryType.sort', {
      entryTypeIDs
    });
  }
}));